module.exports = __webpack_public_path__ + "img/right-arrow-disabled.26582109.svg";